import React from 'react'

const SettingsComponent = () => {
  return (
    <div>SettingsComponent</div>
  )
}

export default SettingsComponent